<div
  class="group relative inline-flex items-center justify-center rounded-full cursor-pointer hover:outline-2 hover:outline-dashed hover:outline-primary"
  (click)="!noFile ? menu.toggle($event) : file.click()"
>
  <p-avatar
    [image]="url"
    [icon]="noFile || !url ? 'pi pi-user' : null"
    size="large"
    shape="circle"
    styleClass="group-hover:opacity-50"
    (onError)="pictureNotLoaded()"
  />
  <i
    class="pi pi-camera absolute top-1/2 start-1/2 -translate-x-1/2 -translate-y-1/2 text-primary text-2xl p-5 hidden group-hover:block pointer-events-none"
  ></i>
</div>

<p-menu #menu [model]="items" [baseZIndex]="1600" [popup]="true" appendTo="body" />

<input #file type="file" accept="image/*" multiple="false" hidden (input)="upload($any($event.target).files[0])" />
